/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_TrInputs */

const en_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from top-right`)
};

const ar_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الزاوية العلوية اليمنى`)
};

const bn_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উপর-ডান থেকে রিসাইজ করুন`)
};

const de_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe von oben rechts ändern`)
};

const es_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde arriba a la derecha`)
};

const fr_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner à partir du coin supérieur droit`)
};

const pt_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar do canto superior direito`)
};

const zh_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从右上角调整大小`)
};

const tr_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağ üstten yeniden boyutlandır`)
};

const ru_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера в правом верхнем углу`)
};

const pl_window_resize_tr = /** @type {(inputs: Window_Resize_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od prawego górnego rogu`)
};

/**
* | output |
* | --- |
* | "Resize from top-right" |
*
* @param {Window_Resize_TrInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_tr = /** @type {((inputs?: Window_Resize_TrInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_TrInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_tr(inputs)
	if (locale === "bn") return bn_window_resize_tr(inputs)
	if (locale === "de") return de_window_resize_tr(inputs)
	if (locale === "es") return es_window_resize_tr(inputs)
	if (locale === "fr") return fr_window_resize_tr(inputs)
	if (locale === "pt") return pt_window_resize_tr(inputs)
	if (locale === "zh") return zh_window_resize_tr(inputs)
	if (locale === "tr") return tr_window_resize_tr(inputs)
	if (locale === "ru") return ru_window_resize_tr(inputs)
	if (locale === "pl") return pl_window_resize_tr(inputs)
	return en_window_resize_tr(inputs)
});